import './logo-nav.scss';

const OPEN_CLASS: string = 'is-open';

document.querySelectorAll<HTMLElement>('.logo-nav').forEach((nav: HTMLElement) => {
    const trigger: HTMLButtonElement | null = nav.querySelector<HTMLButtonElement>('.logo-nav__trigger');
    const dropdown: HTMLElement | null = nav.querySelector<HTMLElement>('.logo-nav__dropdown');

    if (!trigger || !dropdown) {
        return;
    }

    const openDropdown: () => void = (): void => {
        nav.classList.add(OPEN_CLASS);
        dropdown.style.height = `${dropdown.scrollHeight}px`;
        trigger.setAttribute('aria-expanded', 'true');
        dropdown.setAttribute('aria-hidden', 'false');
    };

    const closeDropdown: () => void = (): void => {
        nav.classList.remove(OPEN_CLASS);
        dropdown.style.height = '0';
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.setAttribute('aria-hidden', 'true');
    };

    trigger.addEventListener('click', () => {
        if (nav.classList.contains(OPEN_CLASS)) {
            closeDropdown();
        } else {
            openDropdown();
        }
    });

    document.addEventListener('click', (event: MouseEvent) => {
        if (!nav.contains(event.target as Node) && nav.classList.contains(OPEN_CLASS)) {
            closeDropdown();
        }
    });

    document.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Escape' && nav.classList.contains(OPEN_CLASS)) {
            closeDropdown();
            trigger.focus();
        }
    });
});
